<template>
    <div :class="['input-wrapper', 'form-input-checkbox-toggle', 'form-input-checkbox-toggle--'+size+'', {'form-input-checkbox-toggle--toggle-right': togglePosition === 'right', 'input-wrapper-mb-2x': marginBottomDouble }]">
        <input v-model="inputValue" :id="name" type="checkbox" :name="name">
        <label class="label-static" :for="name">
            <span class="checkbox-toggle-box">
                <span class="checkbox-toggle-box-text checked">{{ __('Yes') }}</span>
                <span class="checkbox-toggle-box-text">{{ __('No') }}</span>
            </span>
            <span v-if="label" class="checkbox-toggle-label">{{ label }}</span>
        </label>

        <form-input-error v-if="hasError" :error="errors[0]"></form-input-error>
        <form-input-note v-else-if="note" :text="note"></form-input-note>
    </div>
</template>

<script>
    export default {
        props: {
            errors: {
                type: Array,
                required: false,
                default: null
            },

            name: {
                type: String,
                required: true
            },

            label: {
                type: String,
                required: false,
                default: null
            },

            required: {
                type: Boolean,
                required: false,
                default: false
            },

            note: {
                type: String,
                required: false,
                default: null
            },

            value: {
                type: Boolean,
                required: false,
                default: null
            },

            togglePosition: {
                type: String,
                required: false,
                default: 'left',
                validator: function (value) {
                    return ['left', 'right'].indexOf(value) !== -1
                }
            },

            marginBottomDouble: {
                type: Boolean,
                required: false,
                default: false
            },

            size: {
                type: String,
                required: false,
                default: 'sm',
                validator: function (value) {
                    return ['sm', 'md', 'lg'].indexOf(value) !== -1
                }
            }
        },

        data() {
            return {
                inputValue: this.value,
                hasError: false
            }
        },

        watch: {
            immediate: true,
            handler(value) {
                if (value.length > 0) {
                    this.hasError = false
                }
            },

            errors: {
                immediate: true,
                handler(errors) {
                    if (errors === null || errors === undefined || errors.length === 0) {
                        this.hasError = false
                    } else {
                        this.hasError = true
                    } 
                }
            }
        }
    }
</script>
